import { isWeiXin, isAndroid } from '@/pages/micro-detail/utils';
export default {
  components: {},
  props: {
    appLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      winxin: isWeiXin(),
      // 安卓标志
      androidFlag: isAndroid()
    };
  },
  mounted() {
    this.$nextTick(() => {
      const btn = document.getElementById('launch-btn');
      if (btn) {
        btn.addEventListener('ready', function (e) {});
        btn.addEventListener('error', e => {
          console.error(e.detail);
          this.jumpApp();
        });
        btn.addEventListener('WeixinOpenTagsError', function (e) {
          console.error(e.detail);
        });
      }
    });
  },
  methods: {
    jumpApp() {
      this.$emit('failJump');
    }
  },
  computed: {}
};